<template>
    <div>
      <Pos_invoices_tax/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax from "@/components/adminArin/pos_system/pos/Pos_invoices_tax";
  export default {
    name: "PosInvoicesTax",
    components: {
      Pos_invoices_tax
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  